<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="main">
			<div class="tabs-box">
				<div class="swiper-container" id="swiper-tabs">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in tabs" :key="index">
							<div class="item"  :class="[(tabs_choose.type === 1 && tabs_choose.type === item.type) || (tabs_choose.type === 3 && tabs_choose.type === item.type) || (tabs_choose.type === 2 && item.branch_id === tabs_choose.branch_id) ? 'active' : '']" @click="changeType(item)">
								<div class="box">
									<div class="tit">{{ item.title }}</div>
									<div class="min" v-if="item.branch_title">{{item.branch_title}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content-box">
				<div class="list" v-if="topic && topic.length > 0">
					<div class="clear item" v-for="(item,index) in topic" :class="[tool.array.inArray(live_active,sessionStatus(item,index)) ? 'active' : '']" @click="toSession(item,index)">
						<div class="left time-box">
							<div class="line line-1"></div>
							<div class=" time"><i></i><div class="t">{{tool.date.formatDate('H:i',item.live_start)}}<br/>-<br/>{{ tool.date.formatDate('H:i',item.live_end) }}</div></div>
							<div class="line line-2"></div>
						</div>
						<div class="left info-box">
							<div class=" info">
								<div class="time-top">{{tool.date.formatDate('H:i',item.live_start)}}-{{ tool.date.formatDate('H:i',item.live_end) }}</div>
								<div class="title">{{item.title}}</div>
								<div class="speaker" v-if="tabs_choose.type === 1 || tabs_choose.type === 3">
									<div class="ll" v-for="(v,i) in item.speaker" v-if="v.username"><span>{{v.username}}</span><i v-if="v.job">|</i><span v-html="v.job"></span></div>
								</div>
								<div class="speaker" v-if="tabs_choose.type === 2">
									<div class="ll" v-if="item.speaker && item.speaker.length > 0"><span>{{item.speaker}}</span><i v-if="item.speaker_job">|</i><span>{{item.speaker_job}}</span></div>
									<div class="ll" v-if="item.speaker2 && item.speaker2.length > 0"><span>{{item.speaker2}}</span><i v-if="item.speaker2_job">|</i><span>{{item.speaker2_job}}</span></div>
									<div class="ll" v-if="item.speaker3 && item.speaker3.length > 0"><span>{{item.speaker3}}</span><i v-if="item.speaker3_job">|</i><span>{{item.speaker3_job}}</span></div>
									<div class="ll" v-if="item.speaker4 && item.speaker4.length > 0"><span>{{item.speaker4}}</span><i v-if="item.speaker4_job">|</i><span>{{item.speaker4_job}}</span></div>
								</div>
								<div class="issue" v-if="item.issue">
									<div class="ll" v-for="(v,i) in item.issue">
										<div class="tit">{{i}}</div>
										<div class="speaker-ll" v-for="(vv,ii) in v" v-if="vv.username"><span>{{vv.username}}</span><i v-if="vv.job">丨</i><span v-html="vv.job"></span></div>
									</div>
								</div>
								<div class="status-box">
									<div class="status" :class="[tool.array.inArray(live_active,sessionStatus(item,index)) ? 'active' : '']">
										<p>{{statusText(sessionStatus(item,index))}}</p>
									</div>
									<div class="star" :class="[inStar(item) ? 'active' : '']" @click.stop="star(item)">
										<p></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="empty-box" v-if="topic.length <= 0 && !data_loading">
					<div class="box">
						<div class="icon"></div>
						<div class="tip-text">进入主会场和分论坛，点击“收藏”您感兴趣的演讲主题，<br/>即可在我的日程中进行查看</div>
						<div class="action">
							<div class="center">
								<div class="btn" @click="$router.push('/plan')">进入主会场</div>
								<div class="btn" @click="$router.push('/branch')">进入分论坛</div>
							</div>
						</div>
					</div>
				</div>
				<div class="data-loading" v-if="data_loading">
					<loading></loading>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Crumbs from "../../../components/m/Crumbs";
import Loading from "../../../components/m/Loading";
export default {
	name: 'plan',
	data() {
		return {
			tabs:[],
			tabs_choose:[],
			session:[],
			topic:[],
			all_mark:true,
			data_loading:true,
			time_list:[],
			now_time:0,
			live_active:[2,3,5],
			star_list:[],
		}
	},
	components:{Crumbs,Loading},
	computed:{
		week_array(){
			return  ["星期日","星期一","星期二","星期三","星期四","星期五","星期六",]
		},
		crumbs() {
			return {title:"我的日程",min_title:"MY AGENDA"}
		},
		is_login(){
			return this.util.getAccessToken();
		}
	},
	watch:{
		now_time(newVal,oldVal){
			if(newVal > oldVal && this.util.inArray(newVal,this.time_list)){
				this.getTopic();
			}
		}
	},
	methods: {
		changeType(item){
			this.tabs_choose = item;
			this.topic =[];
			this.data_loading = true;
			this.getStarList();
		},
		statusText(status){
			var text = ["敬请期待","即将开始","正在直播","已结束","直播回放"];
			return text[status-1];
		},
		setForm(item){
			this.room = item;
			this.getSession();
		},
		inStar(row){
			return  this.star_list.find((item,index)=>{
				return Number(item.topic_id) === Number(row.id)
			})
		},
		star(item){
			if(!this.is_login){
				this.util.showAuth({
					show:true,
					from:"/plan"
				});
			}else{
				this.http.request({
					api:"user/star",
					data:{
						type:this.tabs_choose.type,
						topic_id:item.id,
						branch_id:item.branch_id || ''
					},
					success:(res)=>{
						this.getStarList();
					}
				})
			}
		},
		getStarList(){
			if(!this.is_login){
				return false;
			}
			this.http.request({
				api:"user/starList",
				success:(res)=>{
					this.star_list = res.list;
					this.getBranch();
				}
			})
		},
		toSession(item,index){
			if(this.tabs_choose.type === 2){
				this.toMudu(this.tabs_choose,item,index);
			}else{
				var status = this.sessionStatus(item,index);
				if(!this.tool.array.inArray(this.live_active,status)){
					return false;
				}else{
					if(item.live_url){
						window.open(item.live_url,'_blank');
					}else{
						//var url = this.global.MUDU_HOST +item.live_code;
						if(this.$store.state.user_info.id){
							var router = this.$router.resolve({
								path:"/auth",
								query:{
									live_event:item.live_event,
									live_code:item.live_code,
									live_type:item.live_type,
									title:item.title,
									//redirect:url
								}
							});
							window.open(router.href, '_blank');
						}else{
							var from = `/auth?live_code=${item.live_code}&live_type=${item.live_type}&live_event=${item.live_event}&title=${item.title}`;
							this.util.showAuth({
								show:true,
								from:from
							});
						}
					}
				}
			}
		},
		toMudu(item,vv = '',i = ''){
			var status = this.sessionStatus(item,vv,i);
			if(!this.tool.array.inArray(this.live_active,status)){
				return false;
			}
			if(item.live_url){
				window.open(item.live_url,'_blank');
			}else{
				var live_code = item.live_code;
				if(Number(item.live_status) === 5){
					live_code = vv.live_code;
				}
				//var url = this.global.MUDU_HOST +live_code;
				if(this.$store.state.user_info.id){
					var router = this.$router.resolve({
						path:"/auth",
						query:{
							live_event:item.live_event,
							live_code:live_code,
							live_type:item.live_type,
							//redirect:url
						}
					});
					window.open(router.href, '_blank');
				}else{
					var from = `/auth?live_code=${live_code}&live_type=${item.live_type}&live_event=${item.live_event}`;
					this.util.showAuth({
						show:true,
						from:from
					});
				}
			}
		},
		sessionStatus(item,index){
			if(this.tabs_choose.live_status > 0){
				return this.tabs_choose.live_status;
			}else{
				if(item.live_status > 0){
					return  item.live_status;
				}
				var now_time = this.now_time;
				if(now_time < parseInt(item.live_start)){
					if(index == 0){
						if(now_time < parseInt(item.live_start) - 30*60){
							return 1;
						}else{
							return 2;
						}
					}else{
						return 1;
					}
				}else if(now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)){
					return 3;
				}else{
					return 4;
				}
			}
		},
		removeKey(){
			this.key = "";
			this.getSession();
		},
		getTopic(){
			this.http.request({
				api:"user/starListJoin",
				data:{
					type:this.tabs_choose.type,
					branch_id:this.tabs_choose.branch_id || ''
				},
				success:(res)=>{
					var list = res.list;
					if(this.tabs_choose.type ===1 || this.tabs_choose.type ===3){
						list.map((item,index)=>{
							var issue = {};
							var speaker = [];
							if(item.issue && item.issue.length > 0){
								item.issue.map((v,i)=>{
									if(v.title){
										if(!issue[v.title]){
											issue[v.title] = [];
										}
										issue[v.title].push(v);
									}else{
										speaker.push(v);
									}
								})
							}
							item.issue = Object.getOwnPropertyNames(issue).length > 0 ? issue : false;
							item.speaker = speaker;
						})
					}

					this.topic = list;
					if(this.tool.other.getUrlParams('timer') == 'local'){
						this.now_time = Math.floor(new Date().getTime()/1000);
					}else{
						this.now_time = res.service_time;
					}
					this.refresh();

					var time_list = [];
					for(var i =0;i<this.topic.length;i++){
						time_list.push(this.topic[i].live_start)
						time_list.push(this.topic[i].live_end);
					}
					this.time_list = time_list;

					this.$nextTick(()=>{
						this.data_loading = false;
						this.util.showBottom(true);
					})
				}
			})
		},
		refresh(){
			clearInterval(this.timer);
			this.timer = setInterval(()=>{
				this.now_time = this.now_time+1;
			},1000)
		},
		getBranch(){
			this.http.request({
				api:"branch/getBranch",
				success:(res)=>{
					var list = res.list;
					var branch = [];
					list.map((item,index)=>{
						if(this.getBranchCount(item) > 0){
							branch.push({
								type:2,
								title:"分论坛",
								branch_title:item.title,
								branch_id:item.id,
								live_status:item.live_status,
								live_code:item.live_code,
								live_type:item.live_type,
								live_event:item.live_event,
								live_url:item.live_url,
							});
						}
					})
					var main2_star = this.star_list.filter(((item,index)=>{
						return Number(item.type) === 3;
					}))
					if(main2_star.length > 0){
						branch.unshift({
							type:3,
							title:"第二现场",
						})
					}
					var main_star = this.star_list.filter(((item,index)=>{
						return Number(item.type) === 1;
					}))
					if(main_star.length > 0){
						branch.unshift({
							type:1,
							title:"主会场",
						})
					}

					this.tabs = branch;
					this.$nextTick(()=>{
						this.swiperInit();
					})
					var in_branch = false;
					branch.map((item,index)=>{
						if((item.type === 1 && this.tabs_choose.type === 1) || (item.type === 3 && this.tabs_choose.type === 3) || (item.type === 2 && this.tabs_choose.type ===2 && item.branch_id === this.tabs_choose.branch_id)){
							in_branch = true;
						}
					})
					if(branch.length > 0){
						if((branch.length > 0 && !this.tabs_choose.type) || !in_branch){
							this.tabs_choose = branch[0];
						}
						this.getTopic();
					}else{
						this.topic  =[];
						this.data_loading = false;
					}
				}
			})
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-tabs',{
				slidesPerView:4,
				spaceBetween: 15,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		getBranchCount(branch){
			var list = this.star_list.filter(((item,index)=>{
				return Number( item.type) === 2 && Number(item.branch_id) === Number(branch.id);
			}))
			return list.length;
		}
	},
	mounted() {
		this.query = this.$route.query;
		this.getStarList();
	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.main{
	.tabs-box{padding:.7rem .35rem 0;
		.item{ height:1rem;text-align: center;color:#666;ont-size:.3rem;background: url("~@/assets/image/2025/mobile/tab-bg.png") no-repeat center center;background-size: cover;cursor: pointer;transition: all .3s ease;display: flex;align-items: center;justify-content: center;
			.min{font-size:.22rem;margin-top: .05rem; }
		}
		.item:nth-last-child(1){margin-right: 0;}
		.item.active{color:#fff;background-image: url("~@/assets/image/2025/mobile/tab-bg-active.png");background-size: cover;transition: all .3s ease;font-weight: bold;}
	}
	.content-box{margin: 0 auto;padding: .3rem .35rem .7rem;
		.list{overflow: hidden;
			.item{position: relative;display: flex;flex-wrap: wrap;overflow: hidden;
				.time-box{display: flex;flex-direction: column;width: 1.2rem;display: none;
					.line{position: relative;}
					.line::after{content: "";display: block;position: absolute;left:.15rem;top:0;width: 1px;height:100%;background: #979797;}
					.line-1{height:.2rem;}
					.line-2{flex: 1;}
					.time{font-size:.24rem;line-height:.3rem; font-weight: bold;text-align: right;position: relative;
						i{width: .3rem;height:.3rem; display: block;padding: .1rem 0; background: url("~@/assets/image/2021/14.png") no-repeat left center;background-size:.29rem;}
						.t{position: absolute;left:.4rem;top:.13rem;width: .75rem;}
					}
				}
				.info-box{padding-bottom:.3rem;flex: 1;
					.info{ padding:.25rem .25rem .55rem;background: #fff;box-shadow: 0 0 .1rem .02rem  rgba(0,0,0,.1);position: relative;
						.time-top{font-size:.24rem;font-weight: bold;color:#999999;margin-bottom: .05rem;}
						.title{font-size:.24rem;font-weight: bold;color:#1A1A1A;}
						.speaker{font-size:.22rem;line-height: .33rem; color:#808080;margin-top: .1rem;
							.ll{display: flex;
								span,i{display: block;float: left;}
								span:nth-child(1){min-width: .7rem;display: inline-block;text-align: justify;text-align-last: justify;}
								i{padding: 0 .1rem;}
								span:nth-last-child(1){flex: 1;}
							}
						}
						.issue{margin-top: .1rem; padding-top: .3rem;background: url("~@/assets/image/2021/18.png") no-repeat top center;background-size: 100% .16rem;overflow: hidden;
							.ll{margin-bottom:.4rem;
								.tit{font-size:.22rem;color:#376f84;font-weight: bold;}
								.speaker-ll{font-size:.22rem;line-height: .33rem; color:#808080;margin-top:.1rem;display: flex;
									span,i{display: block;float: left;}
									span:nth-child(1){display: inline-block;}
									i{padding: 0 .1rem;}
									span:nth-last-child(1){flex: 1;}
								}
							}
							.ll:nth-child(2n){margin-right: 0;}
						}
						.status-box{position: absolute;bottom:0;right:0;display: flex;
							.status{width:1.35rem;height:.45rem;text-align: center;line-height:.5rem;background:#9F9F9F;color:#fff;font-size: .22rem;border-right: 1px solid #fff;
								p{padding-left:.2rem;background: url("~@/assets/image/2021/16.png") no-repeat left center;background-size:.12rem;display: inline-block;}
							}
							.status.active{background:#1D56C0;}
							.star{width:1.35rem;height:.45rem;text-align: center;line-height:.5rem;background:#1D56C0;color:#fff;font-size: .22rem;
								p{padding-left:.22rem;background: url("~@/assets/image/2022/10.png") no-repeat left center;background-size:.18rem;display: inline-block;}
								p::after{content: "收藏"}
							}
							.star.active{background:#9F9F9F;
								p{background-image: url("~@/assets/image/2022/11.png");background-size: .18rem;}
								p::after{content: "已收藏"}
							}
						}
					}
				}
			}
			.item.active{cursor: pointer;
				.time{background: url("~@/assets/image/2021/15.png") no-repeat left center;background-size: .29rem;}
			}
			.item:nth-last-child(1){padding-bottom: 0;}
		}
		.empty-box{
			.box{margin: 2rem auto;
				.icon{width:1.29rem;height:1.1rem;background: url("~@/assets/image/2022/14.png") no-repeat center center;background-size: contain;margin: 0 auto;}
				.tip-text{font-size: .22rem;margin-top: .3rem;text-align: center;line-height: .38rem;color:#666666;}
				.action{margin-top: .4rem;display: flex;justify-content: center;
					.center{
						.btn{width: 2.08rem;height:.6rem;text-align: center;line-height: .6rem;color:#fff;background: #0672cb;margin-bottom: .3rem;cursor: pointer;}
						.btn:nth-last-child(1){margin-bottom: 0;}
					}
				}
			}
		}
	}
}
.main::after{content: "";display: block;position: absolute;bottom:0;left:0;width: 100%;height:11rem;background: url("~@/assets/image/2024/mobile/bottom_bg.png") no-repeat left bottom;background-size: contain;pointer-events: none;}
</style>

